class SearchFavouritesRepository {
	constructor($http, appSettings) {
		'ngInject';
		this.http = $http;
		this.endpoint = appSettings.InReachApiSearchFavouritesEndpoint;
	}

	create(favourite) {
		return this.http.post(`${this.endpoint}`, favourite);
	}

	getAll() {
		return this.http.get(this.endpoint);
	}

	get(favouriteId) {
		return this.http.get(`${this.endpoint}/${favouriteId}`);
	}

	update(favouriteId, favourite) {
		return this.http.put(`${this.endpoint}/${favouriteId}`, favourite);
	}

	delete(favouriteId) {
		return this.http.delete(`${this.endpoint}/${favouriteId}`);
	}

	/**
	 * Returns an array of ids representing favourites that were successfully restored for the user & account.
	 * @param {number} favouriteId
	 */
	undoDelete(favouriteId) {
		return this.http
			.patch(`${this.endpoint}`, [SearchFavouritesRepository.buildRestoreOperation(favouriteId)])
			.then(response => {
				const { data } = response;
				const { restoredFavourites } = data;

				return {
					data: restoredFavourites
				};
			});
	}

	static buildRestoreOperation(favouriteId) {
		return { name: 'restore', id: favouriteId };
	}
}

export default SearchFavouritesRepository;
